import { Button, Grid, Typography } from '@material-ui/core';
import { Cancel, CheckCircle, InsertDriveFile, WatchLater } from '@material-ui/icons';
import { MdSpace, Section } from 'm2m.components';
import React, { useEffect, useState } from 'react';

import { AditamentoStatus, IAditamento } from 'common/genericTypes';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { useGenericStyles } from 'common/genericStyles';

interface Props {
  documentos: string;
}

export const DetalhesAditamento: React.FC<Props> = (props) => {
  const { documentos } = props;
  const dispatch = useDispatch();
  const [aditamentos, setAditamentos] = useState<Array<IAditamento>>([]);

  const getAditamentosApi = useSelector((state: RootState) => state.aditamentosApi.getAditamentoById);
  const getAditamentoDoc = useSelector((state: RootState) => state.aditamentosApi.getAditamentoDocument);

  const getAditamentos = async () => {
    const resp = await getAditamentosApi(dispatch, documentos, { page: 0, pageSize: 80000 }, true);
    setAditamentos(resp.result);
  };

  const getAttachmentLink = async (documentId: string, name: string) => {
    try {
      const result = await getAditamentoDoc(dispatch, documentId, true);

      if (result) {
        const link = document.createElement('a');
        link.href = result;
        link.target = '_blank';
        link.download = name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const genericClasses = useGenericStyles();
  const getStatusIcon = (status: AditamentoStatus) => {
    switch (status) {
      case AditamentoStatus.EmAnalise:
        return <WatchLater fontSize="small" className={genericClasses.warningIcon} />;
      case AditamentoStatus.Aprovado:
        return <CheckCircle fontSize="small" className={genericClasses.successIcon} />;
      case AditamentoStatus.Reprovado:
        return <Cancel fontSize="small" className={genericClasses.errorIcon} />;
      default:
        return <></>;
    }
  };

  useEffect(() => {
    getAditamentos();
  }, []);
  return (
    <>
      <Section title={'Termos de Aditamentos'}>
        {aditamentos ? (
          aditamentos.map((aditamento: IAditamento, i: any) => (
            <div key={i}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  borderBottom: '1px solid #C4C4C4',
                  paddingBottom: 40,
                }}
              >
                <Grid container justifyContent={'space-between'} direction={'row'}>
                  <Grid item>
                    <Grid container direction={'row'} justifyContent={'space-between'}>
                      <Typography variant="body1" style={{ marginRight: 50 }}>
                        {getStatusIcon(aditamento.statusAditamentoId)}
                      </Typography>
                      <InsertDriveFile style={{ marginRight: 20 }} fontSize={'small'} />
                      <Typography variant="body1" style={{ marginRight: 50 }}>
                        {aditamento.aditamentoCount}º Aditamento
                      </Typography>
                      <Typography variant="body1">
                        {new Date(Date.parse(aditamento.dataDeCriacao)).toLocaleDateString('pt-BR')}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid item>
                    <Button
                      onClick={() => getAttachmentLink(aditamento.aditamentoGuid, aditamento.codigoInstrumentoFinanceiro)}
                      variant="text"
                    >
                      {'Download'}
                    </Button>
                  </Grid>
                </Grid>
              </div>
              <MdSpace />
            </div>
          ))
        ) : (
          <Typography variant="body1">Não existem aditamentos para esse Instrumento Financeiro</Typography>
        )}
      </Section>
    </>
  );
};
